var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarGraph(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7857 19C19.4563 19 20 19.4477 20 20C20 20.5523 19.4563 21 18.7857 21H4.21429C3.54365 21 3 20.5523 3 20C3 19.4477 3.54365 19 4.21429 19H18.7857ZM18 3C19.1046 3 20 3.89543 20 5V17H3V13C3 11.8954 3.89543 11 5 11H8V9C8 7.89543 8.89543 7 10 7H13V5C13 3.89543 13.8954 3 15 3H18ZM8 13H5V15H8V13ZM13 9H10V15H13V9ZM18 5H15V15H18V5Z",
    fill: "#7E84A3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarGraph);
export default __webpack_public_path__ + "static/media/barGraph.778411c3a7fb10316037620493201da9.svg";
export { ForwardRef as ReactComponent };